function existingSecretaryWA() {
    var WA = ``

    return WA
}

export { existingSecretaryWA }